import React, { useEffect, useRef, useState } from 'react'
import { Cropper } from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import PrimaryButton from '../Button/PrimaryButton'

const ImageInputSecondary = ({
  name,
  required,
  maxFileSize = 5242880,
  allowedFileType = ['image/png', 'image/jpg', 'image/jpeg'],
  width = 390,
  height = 260,
  defaultValue,
  aspectRatio = width / height,
}) => {
  const inputRef = useRef()
  const cropperRef = useRef()
  const [modal, setModal] = useState(false)
  const [currentImage, setCurrentImage] = useState('')

  const onChange = (event) => {
    let file = null
    if (event.target.files && event.target.files.length === 1) {
      file = event.target.files[0]
    }
    if (file === null) {
      return
    }
    if (file.size > maxFileSize) {
      inputRef.current.value = null
      alert('File terlalu besar')
      return
    }
    if (!allowedFileType.includes(file.type)) {
      inputRef.current.value = null
      alert('Tipe file salah')
      return
    }
    setCurrentImage(URL.createObjectURL(file))
    setModal(true)
  }

  const onCancel = () => {
    inputRef.current.value = null
    setCurrentImage('')
    setModal(false)
  }

  const onSave = () => {
    if (typeof cropperRef.current?.cropper !== 'undefined') {
      cropperRef.current?.cropper.getCroppedCanvas().toBlob((blob) => {
        const dataTransfer = new DataTransfer()
        const file = new File([blob], 'profile.png', {
          type: 'image/png',
        })
        dataTransfer.items.add(file)
        inputRef.current.files = dataTransfer.files
        setCurrentImage(
          cropperRef.current?.cropper.getCroppedCanvas().toDataURL(),
        )
        setModal(false)
      })
    }
  }

  useEffect(() => {
    if (defaultValue) {
      setCurrentImage(defaultValue)
    }
  }, [defaultValue])

  return (
    <>
      <div className={`modal ${modal && 'modal-open'}`}>
        <div className="modal-box max-w-2xl">
          <Cropper
            className="w-full h-[400px]"
            ref={cropperRef}
            src={currentImage}
            aspectRatio={aspectRatio}
            guides
          />
          <div className="flex justify-end gap-2 mt-4">
            <PrimaryButton onClick={onCancel}>Batal</PrimaryButton>
            <PrimaryButton onClick={onSave}>Simpan</PrimaryButton>
          </div>
        </div>
      </div>
      <div className="relative">
        <div className="group relative w-full max-w-[832px] h-[320px] rounded-xl border border-dashed border-line bg-subtle overflow-hidden">
          <div
            className={`flex flex-col gap-4 px-8 justify-center items-center h-full w-full`}
          >
            <PrimaryButton
              onClick={() => inputRef.current.click()}
              className={`z-10 transition-all ${'opacity-30 group-hover:opacity-100'}`}
            >
              Upload Gambar
            </PrimaryButton>
            <p
              className={`text-center text-[13px] text-muted z-10 transition-all ${'opacity-30 group-hover:opacity-100'}`}
            >
              Recommended image size: {width} x {height}px - Maximum file size:
              10MB - Supported image files: JPEG or PNG
            </p>
          </div>
          {currentImage && (
            <img
              src={currentImage}
              className={`absolute left-0 top-0 w-full h-full object-contain pointer-events-none z-0 transition-all ${'opacity-100 group-hover:opacity-20'}`}
            />
          )}
        </div>
        <input
          type="file"
          className="hidden"
          name={name}
          ref={inputRef}
          onChange={onChange}
          required={required}
        />
      </div>
    </>
  )
}

export default ImageInputSecondary
